// HeroImage.js
import React, { Component } from 'react';
import './HeroImageStyles2.css';

class HeroImage2 extends Component {
    render() {
        return (
            <div className='hero-img'>
                <div className='heading'>
                    <h1>{this.props.heading}</h1>
                    <p>{this.props.text}</p>
                    {/* Render the link if it's passed as a prop */}
                    <div className='link-container'>
                        {this.props.link} {/* Make sure you change 'button' to 'link' here */}
                    </div>
                </div>
            </div>
        );
    }
}

export default HeroImage2;
